import React, { Component } from 'react'
import DataSyncTable from 'components/dataSyncTable'
import DataTable from 'components/dataTable'
import { aProjects, aUsers } from 'utils/aUtils'
import co from 'co'
import misc from 'utils/misc'
export default class ProjectTable extends Component {

  constructor (props, context) {
    super(props, context)
  }

  state = {
    users: [],
  };

  componentWillMount () {
    let users = []
    co(function *() {
      users = yield aUsers.find()
    })
    .then(() => {
      this.setState({ users })
    })
    .catch(e => {
      console.log(`Error: ${e.stack}`)
      this.setState({ users })
    })
  }

  render () {
    const CellType = DataTable.CellType
    const stageMap = { 0: '未開始', 1: '執行中', 2: '已結束' }
    const userIdMap = misc.getDict(this.state.users, 'name')
    const schemas = [
      { type: CellType.input, title: '專案名稱', key: 'name', width: '19em' },
      { type: CellType.autoComplete, title: '負責人', key: 'usersId', width: '5em', map: userIdMap },
      { type: CellType.dropDown, title: '狀態', key: 'stage', width: '5em', map: stageMap },
    ]

    return (
      <DataSyncTable
        dataUtil={aProjects}
        schemas={schemas}
        radioSelectKey="stage"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/projectTable.jsx